export default "__VITE_ASSET__BFKPUt2C__"